<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2p" id="part01"><a id="page_5"><span class="parts">Part One</span><br/><strong>Fundamentals of Servant Leadership</strong></a></h2><a id="page_5">
<p class="noindent1"><strong>Descriptions of Basic Aspects of Servant Leadership</strong></p>
<p class="bull-lista">•   Ken Blanchard covers his leadership philosophy in “What Is Servant Leadership?” by emphasizing the two parts of servant leadership: the <em>leadership/strategic</em> aspect and the <em>servant/operational</em> aspect.</p>
<p class="bull-lista">•   Larry C. Spears, inspired by his mentor and pioneer in the field of servant leadership Robert K. Greenleaf, discusses “Characteristics of Servant Leaders.”</p>
<p class="bull-lista">•   Raj Sisodia, cofounder of the Conscious Capitalism movement, shows in “Servant Leadership Is Conscious Leadership” how the qualities of <em>servant</em> leaders overlap considerably with those of <em>conscious</em> leaders.</p>
<p class="bull-lista">•   Stephen M. R. Covey, in “Servant Leadership at the Speed of Trust,” reflects on how trust is inextricably linked to the practice of servant leadership.</p>
<p class="bull-lista">•   Mark Miller, in “Great Leaders SERVE,” relates how the SERVE acronym developed at Chick-fil-A can help you become a servant leader.</p>
<p class="bull-lista">•   Mark A. Floyd offers advice to new servant leaders in his essay “Servant Leadership: What Does It Really Mean?”</p>
<p class="bull-lista">•   Michael C. Bush, CEO of Great Places to Work For All, shows that the most extraordinary organizations are led by servant leaders in “Servant Leaders Create a Great Place to Work for All.”</p>
</a><p class="bull-lista"><a id="page_5"></a><a id="page_6">•   Holly Culhane, in “The Leader as Shepherd,” presents a compelling argument that the shepherd is one of the best examples of a servant leader.</a></p><a id="page_6">
<p class="bull-lista">•   Simon Sinek, in “The Evolution of Servant Leadership,” shares his thoughts about the roots of servant leadership—and why it matters.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?faf8ee3e